export default "__VITE_ASSET__DGvlZcJc__"